import React from "react";
import Navbar from "../../Common/Navbar";
import Footer from "../../Common/Footer";
import Sidebar from "../../Sidebar/Sidebar";
import GlobalSummaryComp from "./Component/GlobalSummaryComp";

const GlobalSummary = () => {
  return (
    <>
      <Navbar />
      <div className="d-flex mainContentArea">
        <Sidebar />
        <GlobalSummaryComp />
      </div>
      <Footer />
    </>
  );
};

export default GlobalSummary;
